import windowMatchMedia from '@Front/constants/windowMatchMedia';
import { selectors, classes } from './config';

class JobPostController {
  observer;

  observerOptions = {
    threshold: 0,
  };

  constructor() {
    this.observer = this.#buildObserver();
    this.header = document.querySelector(selectors.header);
    this.stickyFooter = document.querySelector(selectors.stickyFooter);
  }

  shouldRenderStickyFooter() {
    return !windowMatchMedia['break-4'].matches;
  }

  toggleStickyFooter(headerIsVisible) {
    if (this.shouldRenderStickyFooter() && !headerIsVisible) {
      this.stickyFooter.classList.remove(classes.hide);
      return;
    }

    this.stickyFooter.classList.add(classes.hide);
  }

  #buildObserver() {
    const observer = new IntersectionObserver((entries, _observer) => {
      entries.forEach((entry) => {
        const isVisible = entry.isIntersecting;

        this.toggleStickyFooter(isVisible);
      });
    });

    return observer;
  }

  mount() {
    this.observer.observe(this.header, this.observerOptions);
  }
}

const controller = new JobPostController();
controller.mount();
